module.exports = __webpack_public_path__ + "img/uk-hotels-1.d24cd2ed.png";